import React, { useMemo } from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

type Category = {
    id: number;
    name: string;
    children: Category[];
};

type FlattenedCategory = {
    id: number;
    label: string;
    selectable: boolean;
};

type Props = {
    categories: Category[];
    value?: number | "";
    onChange: (categoryId: number) => void;
};

const CategorySelect = ({ categories, value, onChange }: Props) => {
    const flattened = useMemo<FlattenedCategory[]>(() => {
        const result: FlattenedCategory[] = [];

        const walk = (nodes: Category[], parentPath = "") => {
            nodes.forEach((node) => {
                const label = parentPath ? `${parentPath} > ${node.name}` : node.name;

                result.push({
                    id: node.id,
                    label,
                    selectable: node.children.length === 0,
                });

                if (node.children.length > 0) {
                    walk(node.children, label);
                }
            });
        };

        walk(categories);

        return result;
    }, [categories]);

    const handleChange = (event: SelectChangeEvent<string | number>) => {
        onChange(Number(event.target.value));
    };

    return (
        <FormControl fullWidth>
            <InputLabel>Category</InputLabel>
            <Select value={value ?? ""} label="Category" onChange={handleChange}>
                {flattened.map((category) => (
                    <MenuItem key={category.id} value={category.id} disabled={!category.selectable}>
                        {category.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CategorySelect;
